import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var userData5B = localStorage.getItem("userData5B") ? JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B")))) : "";

var serviceName = "index";
var demirService = {
    imageUrlBuyuk: WsProvider.resim + "/" + userData5B["firmaKodu"] + "/buyuk/",
    imageUrlOrta: WsProvider.resim + "/" + userData5B["firmaKodu"] + "/orta/",
    imageUrlKucuk: WsProvider.resim + "/" + userData5B["firmaKodu"] + "/kucuk/",
    imageUrlEnKucuk: WsProvider.resim + "/" + userData5B["firmaKodu"] + "/enkucuk/",
    path  : "https://www.5bmuhendislik.com.tr/",
    demirTanimlama(tarih, demirDizi) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                tarih: tarih,
                demirDizi: demirDizi,
                serviceName: "demir",
                methodName: "demirTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    demirList(baslangic, limit,durum) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                baslangic : baslangic,
                limit : limit,
                durum: durum,
                serviceName: "demir",
                methodName: "demirListesi"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    demirDetay(dfiyatId) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                dfiyatId: dfiyatId,
                serviceName: "demir",
                methodName: "demirDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    demirDurumGuncelle(dfiyatId, durum) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                dfiyatId: dfiyatId,
                durum: durum,
                serviceName: "demir",
                methodName: "demirDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    demirGuncelle(dfiyatId, q8mm,q10mm,q1232mm) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                dfiyatId: dfiyatId,
                q8mm: q8mm,
                q10mm: q10mm,
                q1232mm: q1232mm,
                serviceName: "demir",
                methodName: "demirGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
}

export default demirService

